"use client";

import Script from "next/script";
import { useEffect } from "react";
import { ConsentStore } from "@/app/stores/ConsentStore";
import { ConsentChoice } from "@/app/types/consent/ConsentChoice";
import { UConsent } from "@/app/utils/UConsent";

type Props = {
  gaId?: string;
};

export default function ConsentAnalytics(props: Props) {
  const { gaId } = props;
  const choice = ConsentStore((state) => state.choice);

  useEffect(() => {
    if (gaId) {
      UConsent.setGoogleAnalyticsDisabled(gaId, choice !== ConsentChoice.ACCEPTED);
    }
  }, [gaId, choice]);

  if (!gaId || choice !== ConsentChoice.ACCEPTED) {
    return null;
  }

  return (
    <>
      <Script src={UConsent.googleAnalyticsScriptUrl(gaId)} strategy="afterInteractive" />
      <Script id="google-analytics" strategy="afterInteractive">
        {UConsent.googleAnalyticsInitScript(gaId)}
      </Script>
    </>
  );
}
